export const CATEGORY_COLORS = {
    management: {
        bg: "bg-orange-50",
        border: "border-orange-200",
        accent: "text-orange-600",
        fill: "#FFF7ED",
        stroke: "#EA580C"
    },
    core: {
        bg: "bg-emerald-50",
        border: "border-emerald-200",
        accent: "text-emerald-600",
        fill: "#ECFDF5",
        stroke: "#10B981"
    },
    support: {
        bg: "bg-slate-50",
        border: "border-slate-200",
        accent: "text-slate-600",
        fill: "#F8FAFC",
        stroke: "#64748B"
    },
    uncategorized: {
        bg: "bg-amber-50",
        border: "border-amber-200",
        accent: "text-amber-600",
        fill: "#FFFBEB",
        stroke: "#F59E0B"
    }
};
export function getCategoryColors(key) {
    return CATEGORY_COLORS[key ?? "uncategorized"] ?? CATEGORY_COLORS.uncategorized;
}

//# sourceMappingURL=category-colors.js.map